import axios from 'axios';
import axiosInstance  from './AxiosInstance';
import { store } from '../store/store';

const edmApiBaseUrl = process.env.REACT_APP_API_URL;
const edmLocalHostApiBaseUrl = process.env.REACT_APP_LOCALHOST_API_URL;
const ataccamaBaseUrl = process.env.REACT_APP_ATACCAMA_BASEURL;
const ataccamaUsername = process.env.REACT_APP_ATACCAMA_USERNAME;
const ataccamaPassword = process.env.REACT_APP_ATACCAMA_PASSWORD;
const dbtJobsRoute = process.env.REACT_APP_DBT_JOBS_ROUTE;
const failedDbtJobsRoute = process.env.REACT_APP_FAILED_DBT_JOBS_ROUTE;
const successfulDbtJobsRoute = process.env.REACT_APP_SUCCESSFUL_DBT_JOBS_ROUTE;

export function getDbtJobs() {
    
    const dbtJobsRoute = `${process.env.REACT_APP_DBT_JOBS_ROUTE}`;
    
    return axiosInstance.get(dbtJobsRoute)
        .then(response => {
            
            return response.data.data;
        })
        .catch(error => {
            console.error("!! Error fetching DBT jobs in getDbtJobs:", error);
            throw error;
        });
}

export function getFailedDbtJobs() {
    
    const failedDbtJobsRoute = `${process.env.REACT_APP_FAILED_DBT_JOBS_ROUTE}`;
    

    return axiosInstance.get(failedDbtJobsRoute)
        .then(response => {
    
            return response.data.data;
        })
        .catch(error => {
            console.error("!! Error in getFailedDbtJobs:", error);
            throw error;
        });
}

export function getSuccessfulDbtJobs() {
    
    const successfulDbtJobsRoute = `${process.env.REACT_APP_SUCCESSFUL_DBT_JOBS_ROUTE}`;
    

    return axiosInstance.get(successfulDbtJobsRoute)
        .then(response => {
    
            return response.data.data;
        })
        .catch(error => {
            console.error("!! Error in getSuccessfulDbtJobs:", error);
            throw error;
        });
}

// Export all functions as named exports
